import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { 
  IResultadoResponse, 
  IResultadoRequest,
  IResultadoSaveRequest,
  IResultadoSaveResponse,
  IResultadoDeleteRequest,
  IResultadoDeleteResponse,
  ITipoOpcionRequest,
  ITipoOpcionResponse
} from '../interfaces/resultado.interface';

@Injectable({
  providedIn: 'root'
})
export class ResultadoService {
  private readonly API_URL = `${environment.apiNewBackBaseUrl}Acciones/Cispa_ResCobList`;
  private readonly API_URL_SAVE = `${environment.apiNewBackBaseUrl}GetMnto/GetResCoberr`;
  private readonly API_URL_DELETE = `${environment.apiNewBackBaseUrl}GetMnto/GetResCoberr`;
  private readonly API_URL_TIPOS = `${environment.apiNewBackBaseUrl}OpcionesSolicitud/GetOpcionesVariables`;

  constructor(private http: HttpClient) { }

  getResultados(request: IResultadoRequest): Observable<IResultadoResponse> {
    return this.http.post<IResultadoResponse>(this.API_URL, request);
  }

  getResultadosDefault(): Observable<IResultadoResponse> {
    const payload: IResultadoRequest = {
      que: 0,
      tope: "9999",
      clave: "",
      descripcion: "",
      efectivo: 0
    };
    return this.http.post<IResultadoResponse>(this.API_URL, payload);
  }

  saveResultado(payload: IResultadoSaveRequest): Observable<IResultadoSaveResponse> {
    // TODO: Implementar cuando se tenga el servicio
    return new Observable();
  }

  createResultado(clave: string, descripcion: string, efectivo: number): Observable<IResultadoSaveResponse> {
    const payload: IResultadoSaveRequest = {
      que: 1,
      clave: clave,
      descripcion: descripcion,
      efectivo: efectivo
    };
    return this.http.post<IResultadoSaveResponse>(this.API_URL_SAVE, payload);
  }

  updateResultado(clave: string, descripcion: string, efectivo: number): Observable<IResultadoSaveResponse> {
    const payload: IResultadoSaveRequest = {
      que: 2,
      clave: clave,
      descripcion: descripcion,
      efectivo: efectivo
    };
    return this.http.post<IResultadoSaveResponse>(this.API_URL_SAVE, payload);
  }

  deleteResultado(clave: string): Observable<IResultadoDeleteResponse> {
    const payload: IResultadoDeleteRequest = {
      que: 3,
      clave: clave,
      descripcion: "",
      efectivo: 0
    };
    return this.http.post<IResultadoDeleteResponse>(this.API_URL_DELETE, payload);
  }

  getTiposOpciones(): Observable<ITipoOpcionResponse> {
    const payload: ITipoOpcionRequest = {
      sTabla: "resultados",
      sCampo: "tipo",
      iIdioma: 0
    };
    return this.http.post<ITipoOpcionResponse>(this.API_URL_TIPOS, payload);
  }
} 